import React from 'react';
import { Modal } from 'antd';
import styles from './DspxModal.module.scss';

const DspxModal = (props) => (
  <Modal width={651} {...props} className={props.classModalRegistration ? `${styles.modal} ${styles.modalRegistration}` : styles.modal} />
);

export default DspxModal;
